'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_active_report', {
        template: '<yearly-active-report></yearly-active-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/active_report/yearly/yearly_active_report.routes.js